import { DIGIT_WITHOUT_ZERO_REGEX, ONLY_DIGIT_REGEX } from '@/common/constants/regex/digitRegex';

const monthSecondDigitValidator: Inputmask.Validator = (chrs: string, maskset: Inputmask.MaskSet, pos: number) => {
  const firstDigit = maskset.buffer[pos - 1];

  if (firstDigit === '0') {
    return DIGIT_WITHOUT_ZERO_REGEX.test(chrs);
  }

  if (firstDigit === '1') {
    return /[0-2]/.test(chrs);
  }

  return false;
};

const daySecondDigitValidator: Inputmask.Validator = (chrs: string, maskset: Inputmask.MaskSet, pos: number) => {
  const firstDigit = maskset.buffer[pos - 1];

  if (firstDigit === '0') {
    return DIGIT_WITHOUT_ZERO_REGEX.test(chrs);
  }

  if (firstDigit !== '3') {
    return ONLY_DIGIT_REGEX.test(chrs);
  }

  return /[0-1]/.test(chrs);
};

const yearValidator: Inputmask.Validator = (chrs: string, maskset: Inputmask.MaskSet, pos: number) => {
  const firstDigit = maskset.buffer[pos - 3];
  const secondDigit = maskset.buffer[pos - 2];
  const thirdDigit = maskset.buffer[pos - 1];

  if (firstDigit === '0' && secondDigit === '0' && thirdDigit === '0') {
    return DIGIT_WITHOUT_ZERO_REGEX.test(chrs);
  }

  return ONLY_DIGIT_REGEX.test(chrs);
};

export const MONTH_INPUT_MASK_DEFINITIONS: Inputmask.Definitions = {
  D: {
    validator: '[0-3]',
    cardinality: 1,
  },
  d: {
    validator: daySecondDigitValidator,
    cardinality: 1,
  },
  M: {
    validator: '[01]',
    cardinality: 1,
  },
  m: {
    validator: monthSecondDigitValidator,
    cardinality: 1,
  },
  Y: {
    validator: '[0-9]',
    cardinality: 1,
  },
  y: {
    validator: yearValidator,
    cardinality: 1,
  },
};

export const getInputMaskOptions = (mask: string): Inputmask.Options => ({
  mask,
  definitions: MONTH_INPUT_MASK_DEFINITIONS,
});
